/**
 * Asset Manifest - Single source of truth for all prefetchable assets
 * Edit this file to add/remove assets from the preloader
 */

export const ASSET_MANIFEST = {
  // Critical: Team section images - loaded first
  critical: [
    "/Team_Section_Albert.jpeg",
    "/Team_Section_Dominik.jpeg",
    "/Team_Section_Sahiram.jpeg",
  ],

  // Videos: Shown on work cards (autoplay)
  videos: [
    "/moca/moca.mp4",
    "/pyure/pyure.mp4",
    "/bloom/bloom.mp4",
    "/xtyz/xtyz.mp4",
  ],

  // Secondary: Overlay images - loaded in background after page visible
  secondary: [
    // MOCA
    "/moca/moca-1.png",
    "/moca/moca-2.png",
    "/moca/moca-3.png",
    // PYURE
    "/pyure/pyure-1.png",
    "/pyure/pyure-2.png",
    "/pyure/pyure-3.png",
    // Bloom
    "/bloom/bloom-1.png",
    "/bloom/bloom-2.png",
    "/bloom/bloom-3.png",
    "/bloom/bloom-4.png",
    // xtyz
    "/xtyz/xtyz-1.png",
    "/xtyz/xtyz-2.png",
  ],
};

export const PRELOAD_CONFIG = {
  timeout: 5000, // Max wait before showing page (ms)
};

// Helper to get all primary assets (critical + videos)
export const getPrimaryAssets = () => [
  ...ASSET_MANIFEST.critical,
  ...ASSET_MANIFEST.videos,
];

// Helper to get all assets
export const getAllAssets = () => [
  ...ASSET_MANIFEST.critical,
  ...ASSET_MANIFEST.videos,
  ...ASSET_MANIFEST.secondary,
];
